import React, { useContext, useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import moment from 'moment';

import authContext from '../context/authContext/authContext';
import { useDispatch, useSelector } from 'react-redux';
import { approvePayoutAction, deletePayoutAction, getPayoutsAction, rejectPayoutAction } from '../redux/actions/payoutAction';
import UserDetailsModal from '../components/modals/UserDetailsModal';
import DematStatus from '../components/DematStatus';
import PayoutStatus from '../components/PayoutStatus';

const Payouts = () => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext)

  const [state, setCompleteState] = useState({ reqUserId: '', showUserDetailsModal: false, })
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const { loading, payouts } = useSelector((state) => state.payouts);

  const getPayouts = async () => {
    const config = getConfig()
    dispatch(getPayoutsAction(config))
  }

  useEffect(() => {
    getPayouts();
  }, []);

  const deletePayout = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      reverseButtons: true // 👈 this does the trick
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDeletePayout(id);
      }
    });
  }

  const confirmDeletePayout = async (id) => {
    const data = { id }
    const config = getConfig();
    dispatch(deletePayoutAction(data, config, getPayouts))
  }

  const approvePayout = (id) => {
    const data = { id }
    const config = getConfig();
    dispatch(approvePayoutAction(data, config, getPayouts))
  }

  const rejectPayout = (id) => {
    const data = { id }
    const config = getConfig();
    dispatch(rejectPayoutAction(data, config, getPayouts))
  }

  const onUserIdClick = (userId) => {
    setState({ reqUserId: userId, showUserDetailsModal: true })
  }


  return (
    <div className="main-container">
      <div className="card-box mb-30">
        <div className='table-card-header'>
          <div className='d-flex align-items-center'>
            <h2 className="h4 mb-0 py-2">GleamDesk Payouts</h2>
            {loading ? (
              <div className='ml-3'>
                <div className="spinner-border spinner-border-sm text-primary" role="status" />
              </div>
            ) : null}
          </div>
        </div>
        <div className="overflow-x-scroll">
          <table className="table table-hover text-center">
            <thead>
              <tr>
                <th scope="col">User</th>
                <th scope="col">GT</th>
                <th scope="col">Amount</th>
                <th scope="col">Date</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(payouts || []).map((payout) => {
                const { user, tokens, status, amount, createdAt, _id, userId } = payout;
                return (
                  <tr key={_id}>
                    <th scope="row" className='name cursor-pointer btn-user-info' onClick={() => onUserIdClick(userId)}>{userId}</th>
                    <td>{tokens}</td>
                    <td><strong>{amount}</strong></td>
                    <td>
                      <div>{moment(createdAt).format("DD/MM/YYYY")}</div>
                      <div className='text-muted fs-12'>{moment(createdAt).format("h:mm a")}</div>
                    </td>
                    <td>
                      <PayoutStatus status={status} />
                    </td>
                    <td className='actions-container'>
                      <button className='btn btn-success btn-sm my-1 mx-1' disabled={status !== 'pending' || loading} onClick={() => approvePayout(_id)}>
                        <i className='fa fa-check' />
                      </button>
                      <button className='btn btn-secondary btn-sm my-1 mx-1' disabled={status !== 'pending' || loading} onClick={() => rejectPayout(_id)}>
                        <i className='fa fa-times' />
                      </button>
                      <button className='btn btn-danger btn-sm my-1 mx-1' disabled={status !== 'pending' || loading} onClick={() => deletePayout(_id)}>
                        <i className='fa fa-trash' />
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
      <UserDetailsModal
        isOpen={state.showUserDetailsModal}
        toggle={() => setState({ reqUserId: '', showUserDetailsModal: false })}
        reqUserId={state.reqUserId}
      />
    </div>
  )
}

export default Payouts;